import { DealerLocationID } from "./DealerLocation";
import { User, UserID } from "./User";

export type DeviceID = number;

export type DeviceHistoryID = number;

export interface Device {
  created_on: string;
  updated_on: string;
  id: DeviceID;
  mac_address: string;
  os_version: string;
  brand: string;
  model: string;
  free_space: string;
  is_leased: boolean;
  last_used: string;
  current_user_id: UserID;
  current_user?: User;
  user_history?: DeviceHistory[];
  dealer_location_id: DealerLocationID | null;
}

export interface DeviceHistory {
  created_on: string;
  updated_on: string;
  id: DeviceHistoryID;
  full_name: string;
  dealer_name: string;
  location_name: string;
  role_name: string;
  device_id: DeviceID;
  user_id: UserID;
}
